export default __webpack_public_path__ + "static/media/promoBannerBackground.a6364101.svg";